import { FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const ReceivingMethodContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  #bank-account-country .visible,
  #payout-method .visible {
    display: none !important;
  }
  .section-heading {
    font-size: 16px;
    line-height: 26px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
`;

export const FieldContainer = styled.div`
  margin-bottom: 32px;

  .helperText {
    margin-top: 15px;
  }
`;
